// Generated by CoffeeScript 1.12.7

/**
Removed unsave characters from string

@method escape
@param {String} string the string to escape
@param {Object} options
@param {Object} options.characterMap use a different character map instread of the default
@return {String}
 */
(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    return define('sp/utilities/escape',[], factory);
  } else if (typeof module === 'object' && module.exports) {
    return module.exports = factory();
  } else {
    return root.ensureProtocol = factory();
  }
})(this, function() {
  var escape;
  return escape = function(str, options) {
    var charMap, entities, keys, reEscapedHtml, reUnescapedHtml;
    if (options == null) {
      options = {};
    }
    charMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    if (options.characterMap) {
      charMap = options.characterMap;
    }
    keys = Object.keys(charMap);
    entities = keys.map(function(k) {
      return charMap[k];
    });
    reEscapedHtml = new RegExp("&(?:" + (entities.map(function(val) {
      return val.replace(/(&|;)/g, '');
    }).join('|')) + ");", 'g');
    reUnescapedHtml = new RegExp("[" + (keys.join('')) + "]", 'g');
    if (Object.prototype.toString.call(str) !== '[object String]' || !str.length) {
      return '';
    }
    if (!(keys.some(function(key) {
      return str.indexOf(key) >= 0;
    }))) {
      return str;
    }
    return str.replace(reUnescapedHtml, function(char) {
      return charMap[char];
    });
  };
});

